export default {
  navHome: "Accueil",
  navProducts: "Produits",
  navCases: "Cas d'application",
  navAbout: "À propos",
  deliverTo: "Livrer à :",
  langCurrencyLabel: "Français",
  localeLangTitle: "Définir la langue",
  localeLangDesc:
    "Sélectionnez votre langue préférée. Vous pouvez modifier ce paramètre à tout moment.",
  language: "Langue",
  save: "Enregistrer",
  coreProducts: "Donner vie à la création dans le monde réel.",
  coreProductsDesc:
    "De l'idée à l'entreprise �?YONGYUAN propose des imprimantes UV, des imprimantes d'étiquettes cristal, des imprimantes cylindriques haute vitesse, des imprimantes DTF et DTG, transformant la créativité en produits, marques et opportunités.",
  scenariosTitle: "Des solutions pour chaque scénario",
  scenariosDesc:
    "Que vous construisiez une marque, développiez une activité secondaire ou poursuiviez vos passions créatives, YONGYUAN offre une solution adaptée à vos besoins.",
  scenarioStudio: "Studio",
  scenarioStudioDesc:
    "Personnalisation haut de gamme, prototypage en petites séries et construction de marque",
  scenarioRetail: "Commerce de marque",
  scenarioRetailDesc:
    "Augmenter le temps de présence et les revenus en magasin",
  scenarioMarket: "Marché ambulant",
  scenarioMarketDesc:
    "Personnalisation sur place, vente de produits finis et revenus complémentaires",
  scenarioEnterprise: "Personnalisation entreprise",
  scenarioEnterpriseDesc:
    "Personnalisation en série, merchandising de marque et cadeaux d'entreprise",
  scenarioEcommerce: "Vente en direct",
  scenarioEcommerceDesc:
    "Échantillons de produits phares, approvisionnement flexible et lancements rapides",
  scenarioStore: "Boutique en ligne",
  scenarioStoreDesc:
    "Personnalisation de boutique, merchandising phare et opérations différenciées",
  scenarioFactory: "Production en usine",
  scenarioFactoryDesc:
    "Fabrication en série, production stable et opérations rentables",
  scenarioAdvertising: "Production publicitaire",
  scenarioAdvertisingDesc:
    "Signalétique, supports d'exposition et matériels événementiels",
  industries: "Applications industrielles",
  industriesDesc:
    "Solutions d'impression jet d'encre numérique pour l'impression couleur dans divers secteurs.",
  applicationsTitle:
    "Débloquez des applications polyvalentes de matériaux et de couleurs pour les besoins quotidiens et commerciaux.",
  applicationsDesc:
    "Les équipements d'impression UV YONGYUAN sont conçus pour une large gamme de matériaux et de scénarios de processus, permettant personnalisation et production à grande échelle.",
  casesHeroDesc:
    "Plus de 1200 applications sectorielles et des dizaines de milliers de matériaux imprimables — des solutions d'impression numérique pour chaque activité.",
  casesBreadcrumbHome: "Accueil",
  casesBreadcrumbCenter: "Cas d'application",
  casesEmpty: "Aucun cas d'application dans cette catégorie pour le moment.",
  customerStoriesTitle: "Approuvé par des clients dans le monde entier",
  customerStoriesSubtitle:
    "Des installations réelles, des clients réels, des entreprises d'impression réelles dans 172 pays.",
  customerStoriesStat1Value: "53 000+",
  customerStoriesStat1Label: "Imprimantes livrées",
  customerStoriesStat2Value: "172+",
  customerStoriesStat2Label: "Pays desservis",
  customerStoriesStat3Value: "23+",
  customerStoriesStat3Label: "Années d'expérience",
  customerStoriesStat4Value: "24/7",
  customerStoriesStat4Label: "Support technique",
  customerStoriesPlaceholder: "Ajouter une photo client",
  customerStoriesPhotoAlt: "Client YONGYUAN avec imprimante",
  servicePartnerTitle:
    "Découvrez l'équipe de service YONGYUAN, votre partenaire créatif",
  servicePartnerDesc:
    "Un réseau de service mondial et un système de support professionnel pour protéger les performances de votre équipement et la croissance de votre activité.",
  serviceSupportTitle: "Support standard",
  serviceSupportDesc:
    "Guide d'installation, formation de base et assistance quotidienne pour un fonctionnement fiable de l'équipement.",
  servicePresaleTitle: "Démonstration et consultation avant-vente",
  servicePresaleDesc:
    "Démonstrations de solutions et recommandations de modèles adaptées à vos scénarios d'application et exigences de capacité.",
  serviceLifetimeTitle: "Support technique à vie",
  serviceLifetimeDesc:
    "Réponse technique continue et support de processus pour accompagner votre développement commercial à long terme.",
  serviceCareTitle: "Passez à YONGYUAN Care",
  serviceCareDamageTitle: "Protection contre les dommages accidentels",
  serviceCareDamageDesc:
    "Un plan de protection plus complet pour réduire les pertes causées par des incidents imprévus.",
  serviceCareExchangeTitle: "Service d'échange rapide",
  serviceCareExchangeDesc:
    "Arrangements prioritaires d'échange rapide sous conditions éligibles pour accélérer la récupération de capital.",
  viewProduct: "Voir les produits",
  learnMore: "En savoir plus",
  catUv: "Imprimante UV à plat",
  catCylinder: "Imprimante cylindrique",
  catCrystal: "Imprimante étiquette cristal",
  catDtf: "Imprimante DTF",
  catDtg: "Imprimante DTG",
  companyName: "Shenzhen Yongyuan Technology Co., Ltd.",
  phone: "Téléphone : 17748697567 Manager Tang",
  email: "E-mail : sales@yongyuanprinter.com",
  copyright:
    "Copyright © 2012-2026 Shenzhen Yongyuan Technology Co., Ltd. Tous droits réservés",
  productsHeroTitle: "Produits",
  productsHeroDesc:
    "Gamme complète d'équipements UV à plat, cylindriques, étiquettes cristal, DTF et DTG pour divers besoins de capacité et d'application.",
  productsBreadcrumbHome: "Accueil",
  productsBreadcrumbCenter: "Produits",
  productsEmpty: "Les produits de cette catégorie seront bientôt disponibles.",
  productsQuoteTitle: "Demander une solution et un devis",
  productsQuoteDesc:
    "Partagez vos scénarios d'application et exigences de capacité, et nous vous recommanderons la solution d'équipement adaptée.",
  productsContact: "Nous contacter",
  aboutHeroTitle: "À propos de Yongyuan",
  aboutHeroDesc:
    "23 ans dédiés à la R&D et à la production d'équipements d'impression UV",
  productA23Subtitle: "Imprimante UV intelligente 6 couleurs de bureau",
  productA23Feature1: "Format d'impression A4",
  productA23Feature2: "Système intelligent d'alimentation en encre",
  productA23Feature3: "Détection automatique de hauteur par infrarouge",
  productA35Subtitle: "Imprimante UV intelligente 6 couleurs de bureau",
  productA35Feature1: "Format d'impression A3+",
  productA35Feature2: "Système intelligent d'alimentation en encre",
  productA35Feature3: "Détection automatique de hauteur par infrarouge",
  productA43Subtitle: "Imprimante UV intelligente 8 couleurs phare",
  productA43Feature1: "Format d'impression A3",
  productA43Feature2: "Configurations multiples de têtes d'impression",
  productA43Feature3: "Système intelligent d'alimentation en encre",
  productA46Subtitle: "Imprimante UV intelligente 8 couleurs phare",
  productA46Feature1: "Format d'impression A2",
  productA46Feature2: "Configurations multiples de têtes d'impression",
  productA46Feature3: "Système intelligent d'alimentation en encre",
  productA57Subtitle: "Imprimante UV intelligente 8 couleurs phare",
  productA57Feature1: "Format d'impression A2+",
  productA57Feature2: "Configurations multiples de têtes d'impression",
  productA57Feature3: "Système intelligent d'alimentation en encre",
  productA69Subtitle: "Imprimante UV intelligente 8 couleurs phare",
  productA69Feature1: "Format d'impression A1",
  productA69Feature2: "Configurations multiples de têtes d'impression",
  productA69Feature3: "Système intelligent d'alimentation en encre",
  productA1216Subtitle: "Imprimante UV à plat grand format phare",
  productA1216Feature1: "Format d'impression 1200×1600cm",
  productA1216Feature2: "Configurations multiples de têtes d'impression",
  productA1216Feature3: "Système de positionnement visuel",
  productA2513Subtitle: "Imprimante UV à plat grand format phare",
  productA2513Feature1: "Format d'impression 2500×1300cm",
  productA2513Feature2: "Configurations multiples de têtes d'impression",
  productA2513Feature3: "Système de positionnement visuel",
  productCylinderElfSubtitle: "Imprimante cylindrique haute vitesse 360°",
  productCylinderElfFeature1: "Impression 360°",
  productCylinderElfFeature2: "Personnalisation de gobelets et bouteilles",
  productCylinderElfFeature3: "Changement rapide de gabarits",
  productCupPlusSubtitle: "Solution d'impression multi-tailles pour gobelets et bouteilles",
  productCupPlusFeature1: "Gabarits multi-tailles",
  productCupPlusFeature2: "Haute efficacité de production",
  productCupPlusFeature3: "Production stable",
  productCrystal60Subtitle: "Système tout-en-un impression et dorure d'étiquettes cristal",
  productCrystal60Feature1: "Largeur de 60cm",
  productCrystal60Feature2: "Intégration impression et dorure",
  productCrystal60Feature3: "Système de récupération efficace",
  productCrystalC60UltraFeature1: "Largeur 60 cm",
  productCrystalC60UltraFeature2: "Options dorure/argent/étiquette silicone 3D",
  productCrystalC60UltraFeature3: "Production de masse",
  productCrystal30Subtitle: "Imprimante compacte haute précision pour étiquettes cristal",
  productCrystal30Feature1: "Impression de précision compacte",
  productCrystal30Feature2: "Utilisation facile",
  productCrystal30Feature3: "Personnalisation individuelle",
  productDtf60Subtitle: "Imprimante de transfert DTF à encre blanche",
  productDtf60Feature1: "Transfert DTF à encre blanche",
  productDtf60Feature2: "Couches de couleur riches",
  productDtf60Feature3: "Accessoires vestimentaires",
  productDtfF20Subtitle: "La plus petite imprimante DTF à encre blanche de bureau du secteur",
  productDtfF20Feature1: "Format A4",
  productDtfF20Feature2: "Personnalisation en petites séries",
  productDtfF20Feature3: "Système d'encre intelligent",
  productDtfF30Subtitle: "Imprimante DTF à encre blanche de bureau",
  productDtfF30Feature1: "Format A3",
  productDtfF30Feature2: "Tête unique manuelle/automatique au choix",
  productDtfF30Feature3: "Système d'encre intelligent",
  productDtfF30ProSubtitle: "Imprimante DTF à encre blanche",
  productDtfF30ProFeature1: "Format A3",
  productDtfF30ProFeature2: "Double tête avec enroulement automatique du film",
  productDtfF30ProFeature3: "Système d'encre intelligent",
  productDtfF33Subtitle: "Imprimante DTF à encre blanche",
  productDtfF33Feature1: "Format A3",
  productDtfF33Feature2: "Tête unique manuelle/automatique au choix",
  productDtfF33Feature3: "Système d'encre intelligent",
  productDtfF70ProSubtitle: "Imprimante DTF à encre blanche grand format 70 cm",
  productDtfF70ProFeature1: "Format A2",
  productDtfF70ProFeature2: "Options 2 à 4 têtes d'impression",
  productDtfF70ProFeature3: "Système d'alimentation et de sortie automatique",
  productDtfF70ProFeature4: "Mode de reprise d'impression intelligent",
  productDtf30Subtitle: "Imprimante DTF compacte à encre blanche",
  productDtf30Feature1: "Personnalisation en petites séries",
  productDtf30Feature2: "Reproduction fidèle des couleurs",
  productDtf30Feature3: "Facile à utiliser",
  productDtgPrintSubtitle: "Imprimante numérique directe sur textile",
  productDtgPrintFeature1: "Impression directe multi-matériaux",
  productDtgPrintFeature2: "Haut débit",
  productDtgPrintFeature3: "Stable et durable",
  productDtg3250DSubtitle: "Seul modèle 2-en-1 DTF et DTG du secteur",
  productDtg3250DFeature1: "Format A3+",
  productDtg3250DFeature2: "Impression double processus DTF et DTG",
  productDtg3250DFeature3: "Système d'encre intelligent",
  productDtg3646TSubtitle: "Imprimante DTG double poste",
  productDtg3646TFeature1: "Mode de production continue",
  productDtg3646TFeature2: "Productivité augmentée de 100 %",
  productDtg3646TFeature3: "Système d'encre intelligent",
  productDtgMaxSubtitle: "Imprimante DTG numérique industrielle",
  productDtgMaxFeature1: "Capacité industrielle",
  productDtgMaxFeature2: "Stable et durable",
  productDtgMaxFeature3: "Fonctionnement continu",
  app01Title: "Coques de téléphone",
  app02Title: "Balles de golf",
  app03Title: "Plaques en pierre",
  app04Title: "Stylos à bille",
  app05Title: "Étuis à lunettes",
  app06Title: "Gravures sur bois",
  app07Title: "Canettes de boisson",
  app08Title: "Claviers",
  app09Title: "Gourdes isothermes",
  app10Title: "Bagages",
  app11Title: "Produits en acrylique",
  app12Title: "Carnets",
  app13Title: "Badges",
  app14Title: "Porte-cartes en cuir",
  app15Title: "Plaques d'identification",
  app16Title: "Art sur verre",
  appDtgCase01: "T-shirts",
  appDtgCase02: "Sweats à capuche",
  regionCn: "Chine",
  regionUs: "États-Unis",
  regionGb: "Royaume-Uni",
  regionDe: "Allemagne",
  regionAe: "EAU",
  regionIn: "Inde",
  regionJp: "Japon",
  regionVn: "Vietnam",
  regionBr: "Brésil",
  regionAu: "Australie",

  // synced from en
    uiClose: "Close",
    carouselPrev: "Previous product",
    carouselNext: "Next product",
    heroSlidePrev: "Previous slide",
    heroSlideNext: "Next slide",
    heroSlideDot: "Go to slide {n}",
    customerStoriesTrustedTitle: "Trusted Worldwide",
    customerStoriesBadge: "{count} international customer photos showcased",
    customerStoryCountryUsaNewYork: "New York, USA",
    customerStoryCountryGermany: "Germany",
    customerStoryCountryThailand: "Thailand",
    customerStoryCountrySpain: "Spain",
    customerStoryCountryBrazil: "Brazil",
    customerStoryCountryAustralia: "Australia",
    customerStoryCountrySaudiArabia: "Saudi Arabia",
    customerStoryCountrySingapore: "Singapore",
    customerStoryCountryKorea: "South Korea",
    customerStoryCountryIsrael: "Israel",
    customerStoryCountryKazakhstan: "Kazakhstan",
    customerStoryCountryMexico: "Mexico",
    customerStoryCountryArgentina: "Argentina",
    customerStoryCountryPhilippines: "Philippines",
    customerStoryCountryIndonesia: "Indonesia",
    customerStoryCountryNetherlands: "Netherlands",
    customerStoryCountrySweden: "Sweden",
    customerStoryCountrySouthAfrica: "South Africa",
    customerStoryCountryMalaysia: "Malaysia",
    customerStoryCountryTaiwan: "Taiwan",
    customerStoryCountryUsa: "United States",
    customerStoryCaption01: "USA�?090 UV Printer",
    customerStoryCaption02: "Germany｜F33 DTF Printer",
    customerStoryCaption03: "Thailand�?250 UV Printer",
    customerStoryCaption04: "Spain�?250 UV Printer",
    customerStoryCaption05: "Brazil�?030 UV Printer",
    customerStoryCaption06: "Australia｜F33 DTF Printer",
    customerStoryCaption07: "Saudi Arabia�?030 UV Printer",
    customerStoryCaption08: "Singapore｜F33 DTF Printer",
    customerStoryCaption09: "South Korea｜F33 DTF Printer",
    customerStoryCaption10: "Israel｜UVC33 DTF Printer",
    customerStoryCaption11: "Kazakhstan�?030 UV Printer",
    customerStoryCaption12: "Mexico�?060 UV Printer",
    customerStoryCaption13: "Argentina�?060 UV Printer",
    customerStoryCaption14: "Philippines�?090 UV Printer",
    customerStoryCaption15: "Indonesia�?030 UV Printer",
    customerStoryCaption16: "Netherlands�?030 UV Printer",
    customerStoryCaption17: "Sweden�?060 UV Printer",
    customerStoryCaption18: "Germany�?030 UV Printer",
    customerStoryCaption19: "South Africa�?030 UV Printer",
    customerStoryCaption20: "Malaysia｜F33 DTF Printer",
    customerStoryCaption21: "Taiwan｜UVC33 DTF Printer",
    customerStoryCaption22: "USA｜F70Pro DTF Printer",
    customerStoryCaption23: "USA�?513 UV Printer",
    customerStoryCaption24: "USA�?090 UV Printer",
    customerStoryCaption25: "USA�?030 UV Printer",
    customerStoryCaption26: "USA�?250 UV Printer",
    customerStoryCaption27: "South Korea�?060 UV Printer",
    customerStoryCaption28: "Netherlands�?060 UV Printer",
    catUvNav: "UV Flatbed",
    catCylinderNav: "Cylindrical",
    catCrystalNav: "Crystal Label",
    catDtfNav: "DTF",
    catDtgNav: "DTG",
    productA3220Subtitle: "Ultra Wide-Format Industrial UV Flatbed Solution",
    productA3220Feature1: "320×200cm Print Format",
    productA3220Feature2: "Visual Positioning System",
    productA3220Feature3: "Continuous Batch Production",
    productCrystal60UltraSubtitle: "Flagship Crystal Label Printing Solution",
    cityShanghai: "Shanghai",
    cityShenzhen: "Shenzhen",
    cityDetroit: "Detroit",
    cityManchester: "Manchester",
    cityStuttgart: "Stuttgart",
    cityDubai: "Dubai",
    cityPune: "Pune",
    cityOsaka: "Osaka",
    cityHoChiMinh: "Ho Chi Minh City",
    citySaoPaulo: "São Paulo",
    cityMelbourne: "Melbourne",
};
